import { z } from "zod/v4";

export const AdminCreateUsageBillingUrlRequestBodySchema = z.object({
  orgId: z.uuid(),
  subscriptionLinkId: z.uuid(),
  code: z.string().optional(),
});

export const AdminCreateUsageBillingUrlResponseBodySchema = z.object({
  billingUrl: z.string().optional(),
});

export type AdminCreateUsageBillingUrlRequestBodyType = z.infer<
  typeof AdminCreateUsageBillingUrlRequestBodySchema
>;
export type AdminCreateUsageBillingUrlResponseBodyType = z.infer<
  typeof AdminCreateUsageBillingUrlResponseBodySchema
>;
